import lozad from 'lozad';
import bus from '../util/eventBus';

const lazy = () => {
  const lazyEl = document.querySelector('.u-lazy');

  if (lazyEl) {
    const observer = lozad('.u-lazy', {
      rootMargin: '10px 0px',
      threshold: 0.1,
      loaded: el => {
        bus.emit('ewg-lazy-img-loaded', el);
      },
    });
    const observe = () => observer.observe();
    observe();

    bus.on('ewg-facet-loaded', () => observe());
    bus.on('ewg-social-grid-recalc', () => observe());

    document.addEventListener('DOMContentLoaded', () => observe, {
      once: true,
    });
  }
};

lazy();



// WEBPACK FOOTER //
// ./src/scripts/modules/lazy.js